import React from 'react';
import { HomeIcon, CasesIcon, MessagesIcon, DocumentsIcon, AccountIcon, HelpIcon, LogoutIcon } from './UserDashboardIcons';

interface UserSidebarProps {
  onLogout: () => void;
}

const NavLink: React.FC<{
    icon: React.ReactNode;
    label: string;
    isActive?: boolean;
}> = ({ icon, label, isActive }) => (
    <a href="#" className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive ? 'bg-blue-500 text-white' : 'text-slate-600 hover:bg-blue-100 hover:text-blue-700'}`}>
        {icon}
        <p className="text-sm font-medium">{label}</p>
    </a>
);


export const UserSidebar: React.FC<UserSidebarProps> = ({ onLogout }) => {
  return (
    <aside className="layout-content-container flex flex-col w-72 bg-white bg-opacity-90 backdrop-blur-md rounded-xl shadow-lg p-4 mr-5 sticky top-5 h-screen max-h-[calc(100vh-40px)] overflow-y-auto border border-slate-200">
      <div className="flex flex-col gap-6 h-full">
        <div className="flex items-center gap-3 px-2 pt-2">
            <div className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10 border-2 border-blue-200" style={{backgroundImage: `url("images/user-avatar.png")`}}></div>
            <h1 className="text-blue-800 text-lg font-semibold">Panel de Usuario</h1>
        </div>
        <nav className="flex flex-col gap-2 px-2">
            <NavLink icon={<HomeIcon />} label="Dashboard" isActive />
            <NavLink icon={<CasesIcon />} label="Casos" />
            <NavLink icon={<MessagesIcon />} label="Mensajes" />
            <NavLink icon={<DocumentsIcon />} label="Documentos" />
            <NavLink icon={<AccountIcon />} label="Cuenta" />
        </nav>
        <div className="mt-auto p-2 space-y-2">
            <button className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-slate-600 hover:bg-blue-100 hover:text-blue-700 transition-all duration-200 border border-slate-300">
                <HelpIcon />
                <span className="text-sm font-medium">Ayuda y Soporte</span>
            </button>
            <button 
                onClick={onLogout}
                className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-slate-600 hover:bg-red-100 hover:text-red-700 transition-all duration-200 border border-slate-300">
                <LogoutIcon />
                <span className="text-sm font-medium">Cerrar Sesión</span>
            </button>
        </div>
      </div>
    </aside>
  );
};